import React from "react"
import { routePaths } from "../../../Routes"
import { AuthCheck } from "./AuthCheck"
import { hasResult } from "../../../Models/Client/FetchState"
import {
    hasOrgPermission,
    OrgPermissionScope
} from "../../../Models/Client/OrgPermissionScope"
import { useMyOrgRole } from "../../../Hooks/useMyOrgRole"
import { Loader } from "dash-styled"
import { useAppState } from "../../../Hooks/useReduxState"
import { isAuthenticated } from "../../../Helpers/Functions/Selectors/auth"
import { Redirect } from "react-router"

interface OrgAuthCheckProps {
    orgUsername: string
    scope: OrgPermissionScope
    children: JSX.Element
}

export function OrgAuthCheck({
    orgUsername,
    children,
    scope
}: OrgAuthCheckProps) {
    const myRoleFetch = useMyOrgRole(orgUsername)
    const authenticated = useAppState(isAuthenticated)

    // NOTE: `&& authenticated` for logout to work
    if (!hasResult(myRoleFetch) && authenticated) {
        return <Loader absolute={true} />
    }

    if (
        hasResult(myRoleFetch) &&
        (myRoleFetch.isError || !hasOrgPermission(myRoleFetch.value, scope))
    ) {
        return <Redirect to={routePaths.orgHome(orgUsername)} />
    }

    return <AuthCheck>{children}</AuthCheck>
}
